__turbopack_context__.v({
  "boldSpan": "ImageTextBlockLayout-module__BCh8gq__boldSpan",
  "fullWidthRow": "ImageTextBlockLayout-module__BCh8gq__fullWidthRow",
  "imageTextContainer": "ImageTextBlockLayout-module__BCh8gq__imageTextContainer",
  "imageWrapper": "ImageTextBlockLayout-module__BCh8gq__imageWrapper",
  "root": "ImageTextBlockLayout-module__BCh8gq__root",
  "splitImage": "ImageTextBlockLayout-module__BCh8gq__splitImage",
  "splitImageContainer": "ImageTextBlockLayout-module__BCh8gq__splitImageContainer",
  "textContainer": "ImageTextBlockLayout-module__BCh8gq__textContainer",
  "textPara": "ImageTextBlockLayout-module__BCh8gq__textPara",
  "titleContainer": "ImageTextBlockLayout-module__BCh8gq__titleContainer",
  "titleP": "ImageTextBlockLayout-module__BCh8gq__titleP",
});
